import React from 'react';
import { Box, TableHead, TableRow, TableSortLabel, TableCell } from '@mui/material';

import MUICheckbox from '../checkbox';

const DashboardHeader = ({
    headers,
    disabled,
    allSelected = false,
    handleSort = null,
    handleCheckbox = (event) => console.log('Header checkbox clicked', event),
    sortKey = null,
    sortDir = null,
}) => {
    const mapHeaders = (header) => {
        if (header.sortable === true || header.sortable === undefined) {
            return (
                <TableSortLabel
                    active={sortKey === header.id}
                    direction={sortDir.toLowerCase()}
                    onClick={() => handleSort(header.id)}
                    sx={{ fontWeight: 700, color: 'grey.header', fontSize: '13px' }}
                    disabled={disabled}
                >
                    {header.label}
                </TableSortLabel>
            );
        } else {
            switch (header.type) {
                case 'checkbox':
                    return (
                        <Box sx={{ fontWeight: 700, color: 'grey.header', fontSize: '13px' }}>
                            <MUICheckbox
                                checked={allSelected}
                                onChange={handleCheckbox}
                            />
                        </Box>
                    );
                default:
                    return <Box sx={{ fontWeight: 700, color: 'grey.header', fontSize: '13px' }}>{header.label}</Box>;
            }
        }
    };

    return (
        <TableHead>
            <TableRow>
                {headers?.map((header) => (
                    <TableCell key={`header-${header.id}`}>{mapHeaders(header)}</TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default DashboardHeader;
